export const environment = {
  production: true,
  ocpApimSubscriptionKey: "",
  apimBaseUrl: "https://apis.lightstone.co.za/",
  apiVersion: "v1",
  clientID: "42129a40-38b7-448a-9a58-11f733cd8d06",
  redirectUri: "http://localhost:4200/",
  authority:
    "https://login.lightstone.co.za/tfp/lsgb2c.onmicrosoft.com/B2C_1A_SignUpSignInLSG/",
  workspaceCode: "BakjSPdlJ4SGkzGA",
  tenantId: "08A7DD8C-1B74-4AA9-86E4-A58A18DE70F5",
  onboardingUrl: "",
  scoreIrrelavence: 1,
  cdnBaseUrl: "https://cdn.toolkit.lightstone.co.za/",
  version: {
    full: "prod",
  },
  appInsights: {
    instrumentationKey: "164af70f-f90d-4898-9c87-4a10f0391cc4",
  },
  pdfUrl: "http://pdf.lightstoneproperty.co.za/pdfconvert/convert.aspx",
  unauthenticatedKey: "",
  v1Url: "https://toolkit.lightstoneproperty.co.za",
  apexCdnBaseUrl: "https://cdn.platform.coaxle.co.za",
  invoiceUrl:
    "https://cdn.toolkit.lightstone.co.za/finance/v1/scripts/ls-invoices.js",
  grafanaUrl:
    "https://faro-collector-prod-eu-west-2.grafana.net/collect/be67d73f44a7579cfdd1c3459c3b0864",
  ezConnectBundleProductCode: "PR01448Q7K3",
  supportEmail: "support@lightstone.co.za",
};
